<template class="main">
  <v-container class="container" fluid>
    <Breadcrumbs :items="items" />
    <v-card class="mx-auto" max-width="1000" elevation="1">
      <v-toolbar color="#343F53">
        <v-card-title
          class="headline font-weight-bold d-flex align-center justify-space-between px-4 w-100"
        >
          <span style="color: white">DESPEDIDAS</span>
          <v-btn
            color="white"
            small
            class="mr-2"
            style="font-weight: bold"
            @click="novoPost()"
            v-if="!isOnlyModerador"
          >
            NOVA DESPEDIDA
            <v-icon class="ml-2" dark>mdi-plus-thick</v-icon>
          </v-btn>
        </v-card-title>
      </v-toolbar>

      <v-card-text>
        <v-card class="pa-4" elevation="0" rounded="lg">
          <v-row>
            <!-- Filtro local (para moderador) -->
            <v-col cols="6" class="px-0 pb-0" v-if="isOnlyModerador">
              <v-text-field
                v-model="search"
                label="Filtrar"
                variant="outlined"
                density="compact"
                hide-details
                prepend-inner-icon="mdi-magnify"
                rounded="lg"
                class="bg-white"
              />
            </v-col>

            <!-- Busca no servidor (para não moderador) -->
            <v-col cols="12" v-if="!isOnlyModerador" class="px-0 pb-0">
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="searchValue"
                    label="Buscar por nome ou código"
                    variant="outlined"
                    density="compact"
                    hide-details
                    prepend-inner-icon="mdi-magnify"
                    rounded="lg"
                    class="bg-white"
                    @keyup.enter="buscarDespedidas"
                  />
                </v-col>
                <v-col cols="6" class="d-flex align-center">
                  <v-btn
                    color="#343F53"
                    variant="flat"
                    @click="buscarDespedidas"
                    :loading="loading"
                    :disabled="!searchValue"
                    class="mr-2"
                    size="small"
                  >
                    <v-icon>mdi-magnify</v-icon>
                    Buscar
                  </v-btn>

                  <v-btn
                    variant="outlined"
                    color="#343F53"
                    @click="limparBusca"
                    :disabled="!searchValue"
                    size="small"
                  >
                    <v-icon>mdi-close</v-icon>
                    Limpar
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
        <!-- Loading -->
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="#343F53"
          class="mb-4"
        ></v-progress-linear>

        <!-- Lista de Cards -->
        <div v-else class="mt-8">
          <v-card
            v-for="item in filteredDespedidas"
            :key="item.id"
            class="mb-3"
            elevation="0"
            style="border: 1px solid #dcdfe4"
            rounded="lg"
          >
            <v-card-text class="pa-4">
              <div class="d-flex align-start">
                <!-- Foto -->
                <div>
                  <img
                    :src="
                      getFotoPerfilUrl(item.nome_arquivo_foto_perfil) ||
                      getFotoPadrao(item)
                    "
                    alt="Foto do Perfil"
                    class="foto_perfil"
                  />
                </div>

                <!-- Informações em duas colunas -->
                <div class="flex-grow-1">
                  <v-row dense>
                    <!-- Coluna Esquerda -->
                    <v-col cols="12" md="6">
                      <div class="text-body-2 mb-1">
                        <strong>Código:</strong> {{ item.id }}
                      </div>
                      <div class="text-body-2 mb-1">
                        <strong>Apelido:</strong>
                        {{ item.pessoa_falecida.nome_social }}
                      </div>
                      <div class="text-body-2 mb-1">
                        <strong>Jazigo:</strong>
                        {{ item.localizacao_sepultado }}
                      </div>
                      <div class="text-body-2 mb-1">
                        <strong>Moderador:</strong>
                        {{ item.pessoa_moderador?.nome || "—" }}
                      </div>
                      <div class="text-body-2 mb-1">
                        <strong>Criação:</strong>
                        {{ formatDate(item.dataCreate) }}
                      </div>
                    </v-col>

                    <!-- Coluna Direita -->
                    <v-col cols="12" md="6">
                      <div class="text-body-2 mb-1">
                        <strong>Falecido:</strong>
                        {{ item.pessoa_falecida.nome }}
                      </div>
                      <div class="text-body-2 mb-1">
                        <strong>Cemitério:</strong>
                        {{ item.local_sepultamento }}
                      </div>
                      <div class="text-body-2 mb-1">
                        <strong>Sepultamento:</strong>
                        {{ formatDate(item.data_sepultamento) }}
                      </div>
                      <div class="text-body-2 mb-1">
                        <strong>Telefone:</strong>
                        {{ maskPhone(item.pessoa_moderador?.telefone) || "—" }}
                      </div>
                      <div class="text-body-2 mb-1">
                        <strong>Tipo:</strong> {{ item.tipo }}
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-card-text>

            <v-divider></v-divider>

            <!-- Ações no rodapé com background mais escuro -->
            <v-card-actions class="px-4 py-2" style="background-color: #f5f5f5">
              <div class="d-flex align-center justify-space-between w-100">
                <div class="d-flex align-center">
                  <v-tooltip location="top" text="Visualizar despedida">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        density="compact"
                        rounded="lg"
                        variant="text"
                        @click="abrirDespedida(item.id)"
                        color="#343F53"
                        v-bind="props"
                      >
                        <v-icon size="24">mdi-eye</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                  <v-tooltip location="top" text="Gerenciar moderador">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        color="#343F53"
                        density="compact"
                        rounded="lg"
                        variant="text"
                        v-if="!isOnlyModerador"
                        @click="
                          ajustarModerador(item.pessoa_moderador, item.id)
                        "
                        v-bind="props"
                      >
                        <v-icon size="24">mdi-account-lock</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                  <v-tooltip location="top" text="Compartilhar despedida">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        density="compact"
                        rounded="lg"
                        variant="text"
                        @click="
                          abrirCompartilhar(
                            item.controle.chave,
                            item.apresentacao?.codigo,
                            item.id,
                          );
                          despedidaAtual = item;
                        "
                        color="#343F53"
                        v-bind="props"
                      >
                        <v-icon size="24">mdi-share-variant</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                  <v-tooltip location="top" text="Editar despedida">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        density="compact"
                        rounded="lg"
                        variant="text"
                        @click="gerenciarDespedida(item.id)"
                        color="#343F53"
                        v-bind="props"
                      >
                        <v-icon size="24">mdi-pencil</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                  <v-tooltip
                    v-if="!isOnlyModerador"
                    location="top"
                    :text="
                      item.apresentacao
                        ? `${
                            item.status_apresentacao ? 'AOVIVO' : 'OFFLINE'
                          }: ${
                            item.apresentacao.empresa || 'Sem informações'
                          } - ${item.apresentacao.capela || 'Sem informações'}`
                        : 'Sem informações'
                    "
                    color="red"
                  >
                    <template v-slot:activator="{ props }">
                      <v-btn
                        density="compact"
                        rounded="lg"
                        variant="text"
                        @click="abrirModalCapela(item.id)"
                        :color="item.status_apresentacao ? 'red' : '#343F53'"
                        v-bind="props"
                      >
                        <v-icon size="24">
                          {{
                            item.status_apresentacao
                              ? "mdi-television-play"
                              : "mdi-television"
                          }}
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                  <v-tooltip
                    v-if="!isOnlyModerador && item.apresentacao?.camera"
                    location="top"
                    text="Ver transmissão da capela"
                  >
                    <template v-slot:activator="{ props }">
                      <v-btn
                        density="compact"
                        rounded="lg"
                        variant="text"
                        @click="abrirTransmissao(item)"
                        color="#343F53"
                        v-bind="props"
                      >
                        <v-icon size="24">mdi-video</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                  <v-tooltip location="top" text="Gerenciar mensagens">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        density="compact"
                        rounded="lg"
                        variant="text"
                        @click="gerenciarMensagens(item.id)"
                        color="#343F53"
                        v-bind="props"
                        ><v-badge
                          :content="
                            item.qtd_moderacao > 0 ? item.qtd_moderacao : null
                          "
                          :model-value="item.qtd_moderacao > 0"
                          color="red"
                          max="10"
                        >
                          <v-icon size="24">mdi-chat</v-icon>
                        </v-badge>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </div>

                <!-- Switch Status no final da barra -->
                <div v-if="!isOnlyModerador">
                  <v-switch
                    @click="modificarStatusDespedida(item)"
                    inset
                    :label="item.status_memoria ? 'Ativo' : 'Desativado'"
                    color="green"
                    v-model="item.status_memoria"
                    :loading="loadingStatus"
                    :disabled="loadingStatus"
                    hide-details
                    density="compact"
                    style="transform: scale(0.8)"
                  ></v-switch>
                </div>
              </div>
            </v-card-actions>
          </v-card>

          <!-- Sem dados -->
          <v-card
            v-if="filteredDespedidas.length === 0"
            class="text-center py-8"
            elevation="0"
          >
            <div class="text-medium-emphasis">
              Nenhuma despedida encontrada.
            </div>
          </v-card>
        </div>
        <v-col cols="12" class="text-end">
          <v-pagination
            v-if="!isOnlyModerador && totalPages > 1"
            v-model="currentPage"
            :length="totalPages"
            @update:modelValue="handlePageChange"
            :total-visible="8"
            class="mt-4"
          ></v-pagination>
        </v-col>
      </v-card-text>
    </v-card>
  </v-container>

  <v-dialog v-model="dialogCompartilhar" persistent max-width="900">
    <v-card elevation="8">
      <v-toolbar color="#2c3e50" dark flat>
        <v-toolbar-title class="text-h5 font-weight-medium">
          <v-icon class="mr-3">mdi-share-variant</v-icon>
          Compartilhamento e QR Code
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialogCompartilhar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-0">
        <v-container fluid class="pb-0">
          <!-- Seção Link de Transmissão -->
          <v-row>
            <v-col cols="12" class="pb-0">
              <div class="mb-2">
                <h3 class="text-h6 font-weight-bold mb-2">
                  <v-icon class="mr-2" color="#2c3e50">mdi-video</v-icon>
                  Despedida com Transmissão:
                </h3>
                <p class="text-body-2 text-medium-emphasis mb-3">
                  Compartilhe este link para que as pessoas assistam à cerimônia
                  em tempo real e possam interagir com as mensagens.
                </p>
              </div>

              <v-card elevation="0" class="pa-1" color="blue-grey-50">
                <div class="d-flex align-center gap-2 mb-3">
                  <v-text-field
                    v-model="linkTransmissao"
                    variant="outlined"
                    readonly
                    density="comfortable"
                    hide-details
                    color="#2c3e50"
                    class="flex-grow-1"
                    prepend-inner-icon="mdi-link"
                    placeholder="Link da transmissão"
                  />
                  <v-tooltip text="Copiar link">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        v-bind="props"
                        icon="mdi-content-copy"
                        variant="text"
                        color="#2c3e50"
                        size="small"
                        @click="copiarLink(linkTransmissao)"
                      />
                    </template>
                  </v-tooltip>
                  <v-tooltip text="Compartilhar">
                    <template v-slot:activator="{ props }">
                      <v-btn
                        v-bind="props"
                        icon="mdi-share-variant"
                        variant="text"
                        color="#2c3e50"
                        size="small"
                        @click="compartilharLink(linkTransmissao)"
                      />
                    </template>
                  </v-tooltip>
                </div>
                <p class="text-body-2 text-medium-emphasis mb-3">
                  Caso acesse a despedida e seja solicitado um código de acesso,
                  use o código abaixo:
                </p>
                <v-alert
                  type="info"
                  color="#2c3e50"
                  variant="tonal"
                  density="compact"
                  class="mb-0"
                >
                  <strong>Código de Acesso:</strong> {{ codigoToken }}
                </v-alert>
              </v-card>
            </v-col>
          </v-row>

          <v-divider class="my-2"></v-divider>

          <!-- Seção QR Code e Link das Despedidas -->
          <v-row>
            <v-col cols="12">
              <div class="mb-4">
                <h3 class="text-h6 font-weight-bold mb-2">
                  <v-icon class="mr-2" color="#2c3e50">mdi-qrcode</v-icon>
                  Listagem das Despedidas:
                </h3>
                <p class="text-body-2 text-medium-emphasis mb-3">
                  QR Code e link para acesso às mensagens de despedida (ideal
                  para lápides e placas comemorativas)
                </p>
              </div>

              <v-row>
                <v-col cols="12" md="6" class="d-flex flex-column align-center">
                  <v-card
                    variant="outlined"
                    class="pa-4 d-flex flex-column align-center"
                  >
                    <div ref="qrCodeContainer">
                      <qrcode-vue :value="value_qrcode" :size="200" level="H" />
                    </div>
                    <v-btn
                      variant="outlined"
                      color="#2c3e50"
                      @click="downloadQRCode"
                      prepend-icon="mdi-download"
                      class="mb-2"
                      size="small"
                    >
                      Baixar QR Code
                    </v-btn>
                    <p class="text-caption text-center text-medium-emphasis">
                      Escaneie com a câmera do celular
                    </p>
                  </v-card>
                </v-col>

                <v-col cols="12" md="6">
                  <v-card elevation="0" class="pa-4 h-100">
                    <h4 class="text-subtitle-1 font-weight-bold mb-3">
                      Link de Acesso Direto
                    </h4>
                    <div class="d-flex align-center gap-2 mb-3">
                      <v-text-field
                        v-model="linkGrupoDespedidas"
                        variant="outlined"
                        readonly
                        density="comfortable"
                        hide-details
                        color="#2c3e50"
                        class="flex-grow-1"
                        prepend-inner-icon="mdi-heart"
                      />
                      <v-tooltip text="Copiar link">
                        <template v-slot:activator="{ props }">
                          <v-btn
                            v-bind="props"
                            icon="mdi-content-copy"
                            variant="text"
                            color="#2c3e50"
                            size="small"
                            @click="copiarLink(linkGrupoDespedidas)"
                          />
                        </template>
                      </v-tooltip>
                      <v-tooltip text="Compartilhar">
                        <template v-slot:activator="{ props }">
                          <v-btn
                            v-bind="props"
                            icon="mdi-share-variant"
                            variant="text"
                            size="small"
                            color="#2c3e50"
                            @click="compartilharLink(linkGrupoDespedidas)"
                          />
                        </template>
                      </v-tooltip>
                    </div>
                    <p class="text-caption text-medium-emphasis">
                      Compartilhe este link para que familiares e amigos possam
                      deixar suas mensagens de carinho
                    </p>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-divider class="my-2"></v-divider>

          <!-- Seção Informativo -->
          <v-row>
            <v-col cols="12">
              <div class="mb-4">
                <h3 class="text-h6 font-weight-bold mb-2">
                  <v-icon class="mr-2" color="#2c3e50"
                    >mdi-file-document</v-icon
                  >
                  Material Informativo
                </h3>
                <p class="text-body-2 text-medium-emphasis mb-3">
                  Baixe o material informativo com todos os detalhes da
                  cerimônia
                </p>
              </div>

              <v-card class="pa-0 text-center" elevation="0">
                <v-btn
                  variant="outlined"
                  color="#2c3e50"
                  size="small"
                  @click="downloadInformativo(despedidaAtual)"
                  :loading="renderizarInformativo"
                  prepend-icon="mdi-download"
                  class="mb-2"
                >
                  Baixar Informativo
                </v-btn>
                <v-btn
                  variant="outlined"
                  color="#2c3e50"
                  size="small"
                  @click="downloadEBook(despedidaAtual)"
                  :loading="renderizarEbook"
                  prepend-icon="mdi-download"
                  class="mb-2 ml-4"
                >
                  Baixar Ebook
                </v-btn>
                <p class="text-caption text-medium-emphasis">
                  Imagem com informações detalhadas da despedida
                </p>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="pa-2 pt-0">
        <v-spacer></v-spacer>
        <v-btn
          color="#2c3e50"
          variant="flat"
          @click="dialogCompartilhar = false"
          prepend-icon="mdi-close"
        >
          Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- Componente Informativo oculto para captura de imagem -->
  <div
    style="position: absolute; left: -9999px; top: 0"
    v-show="renderizarInformativo"
  >
    <div id="informativo-container" style="width: 500px">
      <Informativo :dados="despedidaAtual" />
    </div>
  </div>

  <div
    style="position: absolute; left: -9999px; top: 0"
    v-show="renderizarEbook"
  >
    <div id="ebook-container">
      <EBook :dados="despedidaAtual" />
    </div>
  </div>

  <!-- Dialog Transmissão da Câmera -->
  <v-dialog v-model="dialogTransmissao" max-width="900">
    <v-card>
      <v-toolbar color="#343F53" dark>
        <v-toolbar-title>
          <v-icon class="mr-2">mdi-video</v-icon>
          Transmissão da Capela 
          <span v-if="transmissaoSelecionada">
            ({{ transmissaoSelecionada.empresa }} - {{ transmissaoSelecionada.capela }})
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fecharTransmissao">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      
      <v-card-text class="pa-4">
        <!-- Mensagem: Transmissão Encerrada -->
        <div v-show="transmissaoEncerrada" class="text-center py-8">
          <v-icon size="64" color="red">mdi-video-off</v-icon>
          <div class="text-h6 mt-4" style="color: #c00">
            Transmissão Encerrada
          </div>
        </div>

        <!-- Mensagem: Transmissão Desativada -->
        <div v-show="transmissaoDesativada" class="text-center py-8">
          <v-icon size="64" color="red">mdi-video-off</v-icon>
          <div class="text-h6 mt-4" style="color: #c00">
            Transmissão Desativada
          </div>
        </div>

        <!-- Mensagem: Transmissão em Breve -->
        <div v-show="transmissaoEmBreve" class="text-center py-8">
          <v-icon size="64" color="grey">mdi-clock-outline</v-icon>
          <div class="text-h6 mt-4" style="color: #888">
            Transmissão em breve
          </div>
        </div>

        <!-- Mensagem: Nenhuma transmissão -->
        <div
          v-show="
            !transmissaoSelecionada &&
            !transmissaoEncerrada &&
            !transmissaoDesativada &&
            !transmissaoEmBreve
          "
          class="text-center py-8"
        >
          <v-icon size="64" color="grey">mdi-video-off-outline</v-icon>
          <div class="text-body-1 mt-4 text-medium-emphasis">
            Nenhuma transmissão disponível
          </div>
        </div>

        <!-- Player de Vídeo (sempre no DOM, controlado por v-show) -->
        <div
          v-show="
            transmissaoSelecionada &&
            !transmissaoEncerrada &&
            !transmissaoDesativada &&
            !transmissaoEmBreve
          "
          class="video-player"
        >
          <video
            ref="videoPlayerAdmin"
            controls
            muted
            playsinline
            style="width: 100%; border-radius: 8px"
          ></video>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>

  <v-dialog v-model="dialoCapela" persistent max-width="600">
    <v-card>
      <v-toolbar color="#343F53">
        <v-card-title class="text-h5 grey lighten-2">
          <span class="font-weight-bold">Exibição Capela</span>
        </v-card-title>
      </v-toolbar>
      <v-row class="my-8 mx-4">
        <v-col cols="12" class="py-0">
          <v-select
            v-model="capela.empresa"
            :items="unidades"
            item-title="nome"
            item-value="sigla"
            label="Unidade"
            variant="outlined"
            density="comfortable"
            prepend-inner-icon="mdi-domain"
          ></v-select>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-select
            :items="capelasDisponiveis"
            label="Número"
            v-model="capela.capela"
            variant="outlined"
            density="comfortable"
            prepend-inner-icon="mdi-church-outline"
          ></v-select>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-text-field
            v-model="capela.dataHoraInicial"
            label="Data e Hora Inicial"
            type="datetime-local"
            variant="outlined"
            density="comfortable"
            prepend-inner-icon="mdi-calendar-start"
          ></v-text-field>
        </v-col>
        <v-col cols="12" class="py-0">
          <v-text-field
            v-model="capela.dataHoraFinal"
            label="Data e Hora Final"
            type="datetime-local"
            variant="outlined"
            density="comfortable"
            prepend-inner-icon="mdi-calendar-end"
          ></v-text-field>
        </v-col>
        <v-col cols="6" class="py-0">
          <v-switch inset color="green" v-model="capela.status">
            <template v-slot:label>
              Exibição capela {{ capela.status ? "ativada" : "desativada" }}
            </template>
          </v-switch>
          <v-switch inset color="green" v-model="capela.status_camera">
            <template v-slot:label>
              Câmera {{ capela.status_camera ? "ativada" : "desativada" }}
            </template>
          </v-switch>
          <a
            :href="getUrlCapela(capela.empresa, capela.capela)"
            target="_blank"
            style="text-decoration: none; color: #343f53"
          >
            <v-icon left dark>mdi-open-in-new</v-icon> Visualizar
          </a>
        </v-col>
      </v-row>

      <v-card-actions class="d-flex justify-end">
        <v-btn text class="botao" color="#343F53" @click="fecharModalCapela()">
          <v-icon left dark>mdi-close-circle</v-icon>
          Fechar
        </v-btn>
        <v-btn
          variant="flat"
          class="botao"
          color="#343F53"
          @click="salvarCapela()"
        >
          <v-icon left dark>mdi-check-bold</v-icon>
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { toPng } from "html-to-image";
import { jsPDF } from "jspdf";
import { useToast } from "vue-toastification";
const toast = useToast();
import { http } from "@/services/config";
import QrcodeVue from "qrcode.vue";
import authHeader from "@/services/auth-header";
import Breadcrumbs from "@/components/utils/Breadcrumbs.vue";
const urlBase = "https://parquedasrecordacoes.com.br";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import Informativo from "../utils/Informativo.vue";
import EBook from "../utils/EBook.vue";
import { injectFotoPerfilParaExport } from "@/utils/injectFotoPerfilExport";
import Hls from "hls.js";

dayjs.locale("pt-br");

/** Evita que html-to-image tente ler CSS de fontes remotas (CORS / SecurityError em produção). */
const toPngExportOptions = {
  quality: 0.95,
  backgroundColor: "#FFFFFF",
  skipFonts: true,
};

function waitForImagesInElement(element) {
  if (!element) return Promise.resolve();
  const imgs = element.querySelectorAll("img");
  return Promise.all(
    [...imgs].map(
      (img) =>
        new Promise((resolve) => {
          if (img.complete) {
            resolve();
            return;
          }
          img.addEventListener("load", resolve, { once: true });
          img.addEventListener("error", resolve, { once: true });
        }),
    ),
  );
}

export default {
  components: {
    QrcodeVue,
    Breadcrumbs,
    Informativo,
    EBook,
  },
  computed: {
    filteredDespedidas() {
      if (!this.search || !this.serverItems) return this.serverItems;

      const searchLower = this.search.toLowerCase();
      return this.serverItems.filter((item) => {
        // Verificar se o item e suas propriedades existem antes de acessá-las
        return (
          (item.pessoa_falecida &&
            item.pessoa_falecida.nome &&
            item.pessoa_falecida.nome.toLowerCase().includes(searchLower)) ||
          (item.pessoa_moderador &&
            item.pessoa_moderador.nome &&
            item.pessoa_moderador.nome.toLowerCase().includes(searchLower)) ||
          (item.localizacao_sepultado &&
            item.localizacao_sepultado.toLowerCase().includes(searchLower)) ||
          (item.local_sepultamento &&
            item.local_sepultamento.toLowerCase().includes(searchLower)) ||
          (item.contrato_jazigo &&
            item.contrato_jazigo.toLowerCase().includes(searchLower)) ||
          (item.contrato_plano &&
            item.contrato_plano.toLowerCase().includes(searchLower)) ||
          (item.id && item.id == searchLower)
        );
      });
    },
    capelasDisponiveis() {
      // Encontrar o nome da unidade baseado na sigla selecionada
      const unidadeSelecionada = this.unidades.find(
        (u) => u.sigla === this.capela.empresa,
      );
      return unidadeSelecionada
        ? this.capelasPorUnidade[unidadeSelecionada.nome] || []
        : [];
    },
    isOnlyModerador() {
      return (
        this.roles.includes("ROLE_MODERADOR") &&
        !this.roles.includes("ROLE_ADMIN") &&
        !this.roles.includes("ROLE_COLABORADOR")
      );
    },
    getUrlCapela() {
      return (empresa, capela) => {
        if (typeof window !== "undefined") {
          return `${window.location.origin}/capela/${empresa}/${capela}`;
        }
        return `https://parquedasrecordacoes.com.br/capela/${empresa}/${capela}`;
      };
    },
  },
  data: () => ({
    renderizarInformativo: false,
    renderizarEbook: false,
    despedidaAtual: null,
    currentPage: 1,
    totalPages: 1,
    searchValue: "",
    isBuscaAtiva: false,
    items: [
      {
        title: "Início",
        disabled: false,
        href: "/admin/despedidas",
      },
    ],
    unidades: [
      { nome: "Central de Velórios", sigla: "CV" },
      { nome: "Parque das Flores", sigla: "PF" },
      { nome: "Memorial Parque Maceió", sigla: "ME" },
      { nome: "Cemitério Previda", sigla: "CP" },
      { nome: "Parque do Agreste", sigla: "AM" },
    ],
    capelasPorUnidade: {
      "Memorial Parque Maceió": ["01", "02", "03", "04", "05", "06", "07"],
      "Central de Velórios": ["01", "02", "03", "04"],
      "Parque das Flores": ["01", "02", "03", "04"],
      "Cemitério Previda": ["01", "02", "03"],
      "Parque do Agreste": ["01", "02", "03"],
    },
    capela: {
      id: 0,
      id_despedida: 0,
      empresa: "",
      capela: "",
      dataHoraInicial: "",
      dataHoraFinal: "",
      status: true,
      status_camera: true,
    },
    toolTipCapela: {
      empresa: "",
      capela: "",
      status: false,
    },
    loadingTooltip: false,
    dialoCapela: false,
    loadingStatus: false,
    itemsPerPage: 10,
    headers: [
      { text: "Avatar", value: "foto", title: "Avatar", sortable: false },
      {
        text: "Informações",
        value: "nome",
        title: "Informações",
        sortable: false,
      },
    ],
    search: null,
    serverItems: [],
    loading: true,
    totalItems: 0,
    dialogCompartilhar: false,
    value_qrcode: "",
    roles: [],
    linkGrupoDespedidas: "",
    linkTransmissao: "",
    codigoToken: "",
    dialogTransmissao: false,
    transmissaoSelecionada: null,
    transmissaoEncerrada: false,
    transmissaoDesativada: false,
    transmissaoEmBreve: false,
    hlsPlayer: null,
    isInitializingPlayer: false,
    playerRetryCount: 0,
    maxPlayerRetries: 3,
  }),
  mounted() {
    this.setRolesFromSession();
    this.consultarDespedidas();
  },
  beforeUnmount() {
    this.destroyHlsPlayer();
  },
  methods: {
    getFotoPadrao(item) {
      const sexo = item?.pessoa_falecida?.sexo || "Masculino";
      return sexo === "Feminino"
        ? require("@/assets/feminino.png")
        : require("@/assets/masculino.png");
    },
    async abrirTransmissao(item) {
      // Resetar estados
      this.resetTransmissaoStates();

      this.transmissaoSelecionada = item.apresentacao;
      this.dialogTransmissao = true;

      // Verificar status da transmissão
      const agora = new Date();
      const dataFinal = new Date(item.apresentacao.dataHoraFinal);
      const dataInicial = new Date(item.apresentacao.dataHoraInicial);

      if (!item.apresentacao.status_camera || !item.apresentacao.status) {
        this.transmissaoDesativada = true;
        return;
      }

      if (agora > dataFinal) {
        this.transmissaoEncerrada = true;
        return;
      }

      if (agora < dataInicial) {
        this.transmissaoEmBreve = true;
        return;
      }

      await this.$nextTick();
      await this.buscarStreamUrl(item);
    },
    async buscarStreamUrl(item) {
      if (this.isInitializingPlayer) {
        return;
      }

      this.isInitializingPlayer = true;

      try {
        if (!item.apresentacao || !item.apresentacao.camera) {
          return;
        }

        if (!item.apresentacao.codigo) {
          return;
        }

        const camera = item.apresentacao.camera;
        const codigo = item.apresentacao.codigo;
        const url = `api/videos/stream/${camera}?codigo=${codigo}`;

        const response = await http.get(url, {
          headers: authHeader(),
          responseType: "text",
        });

        const resposta =
          response.data && typeof response.data === "string"
            ? response.data.trim()
            : "";

        // Verificar respostas de status
        if (resposta === "Transmissão encerrada") {
          this.transmissaoEncerrada = true;
          return;
        }

        if (resposta === "Transmissão em breve") {
          this.transmissaoEmBreve = true;
          return;
        }

        if (resposta === "Transmissão Desativada") {
          this.transmissaoDesativada = true;
          return;
        }

        // URL válida do stream - inicializar player
        if (resposta && resposta.startsWith("http")) {
          await this.$nextTick();
          await this.iniciarHlsPlayer(resposta);
        } else {
          toast.error("URL de stream inválida");
        }
      } catch (error) {
        toast.error("Erro ao carregar transmissão");
      } finally {
        this.isInitializingPlayer = false;
      }
    },
    async iniciarHlsPlayer(streamUrl) {
      // Destruir player anterior se existir
      this.destroyHlsPlayer();

      // Aguardar o DOM estar pronto
      await this.$nextTick();

      // Obter referência ao elemento de vídeo usando $refs
      const videoElement = this.$refs.videoPlayerAdmin;

      if (!videoElement) {
        toast.error("Erro ao inicializar player de vídeo");
        return;
      }
      if (Hls && Hls.isSupported()) {
        this.hlsPlayer = new Hls({
          maxMaxBufferLength: 60,
          maxBufferSize: 50 * 1024 * 1024,
          maxBufferLength: 20,
          lowLatencyMode: false,
          enableWorker: true,
          backBufferLength: 15,
        });

        this.hlsPlayer.loadSource(streamUrl);
        this.hlsPlayer.attachMedia(videoElement);

        // Event: Manifesto parseado
        this.hlsPlayer.on(Hls.Events.MANIFEST_PARSED, () => {
          videoElement
            .play()
            .then(() => {
              this.playerRetryCount = 0;
            })
            .catch(() => {
              // Autoplay bloqueado - usuário precisa interagir
            });
        });

        // Event: Erro
        this.hlsPlayer.on(Hls.Events.ERROR, (event, data) => {
          if (data.fatal) {
            this.handleHlsError(data, streamUrl);
          }
        });

        // Eventos de fragmento removidos para evitar logs excessivos
      } else if (videoElement.canPlayType("application/vnd.apple.mpegurl")) {
        // Fallback para Safari (suporte nativo HLS)
        videoElement.src = streamUrl;

        videoElement.addEventListener("loadedmetadata", () => {
          videoElement.play().catch(() => {
            // Autoplay bloqueado
          });
        });

        videoElement.addEventListener("error", () => {
          toast.error("Erro ao carregar transmissão");
        });
      } else {
        toast.error("Seu navegador não suporta reprodução de vídeo HLS");
      }
    },
    handleHlsError(data, streamUrl) {
      switch (data.type) {
        case Hls.ErrorTypes.NETWORK_ERROR:
          if (this.playerRetryCount < this.maxPlayerRetries) {
            this.playerRetryCount++;

            setTimeout(() => {
              if (this.hlsPlayer) {
                this.hlsPlayer.startLoad();
              }
            }, 1000);
          } else {
            toast.error("Falha na conexão após várias tentativas");
            this.destroyHlsPlayer();
          }
          break;

        case Hls.ErrorTypes.MEDIA_ERROR:
          if (this.playerRetryCount < this.maxPlayerRetries) {
            this.playerRetryCount++;

            if (this.hlsPlayer) {
              this.hlsPlayer.recoverMediaError();
            }
          } else {
            // Tentar recriar o player completamente
            this.destroyHlsPlayer();
            setTimeout(() => {
              this.iniciarHlsPlayer(streamUrl);
            }, 2000);
          }
          break;

        default:
          toast.error("Erro fatal na reprodução do vídeo");
          this.destroyHlsPlayer();
          break;
      }
    },
    destroyHlsPlayer() {
      if (this.hlsPlayer) {
        try {
          this.hlsPlayer.destroy();
        } catch (error) {
          // Erro ao destruir player
        }

        this.hlsPlayer = null;
      }

      // Limpar elemento de vídeo
      const videoElement = this.$refs.videoPlayerAdmin;
      if (videoElement) {
        videoElement.pause();
        videoElement.removeAttribute("src");
        videoElement.load();
      }

      this.playerRetryCount = 0;
    },
    resetTransmissaoStates() {
      // Destruir player anterior
      this.destroyHlsPlayer();

      // Resetar flags
      this.transmissaoEncerrada = false;
      this.transmissaoDesativada = false;
      this.transmissaoEmBreve = false;
      this.isInitializingPlayer = false;
      this.playerRetryCount = 0;
    },
    fecharTransmissao() {
      // Limpar player e resetar estados
      this.resetTransmissaoStates();

      // Fechar dialog
      this.dialogTransmissao = false;
      this.transmissaoSelecionada = null;
    },
    abrirCompartilhar(cod, token, idDespedida) {
      this.dialogCompartilhar = true;
      this.linkGrupoDespedidas = urlBase + "/despedidas/" + cod;
      this.value_qrcode = urlBase + "/despedidas/" + cod;
      this.linkTransmissao = token
        ? urlBase + "/despedida/" + idDespedida + "/" + token
        : urlBase + "/despedida/" + idDespedida;
      this.codigoToken = token;
    },
    compartilharLink(value) {
      if (navigator.share) {
        navigator
          .share({
            title: "Link de Transmissão",
            text: "Compartilhe este link para transmissão da despedida",
            url: value,
          })
          .then(() => {
            console.log("Compartilhamento realizado com sucesso!");
          })
          .catch((error) => {
            console.error("Erro ao compartilhar:", error);
          });
      } else {
        this.copiarLink();
        alert(
          "Compartilhamento não suportado neste dispositivo. O link foi copiado para a área de transferência.",
        );
      }
    },
    // Fechar o pop-up e restaurar objeto para o padrão
    fecharModalCapela() {
      this.dialoCapela = false;
      this.capela = {
        id: 0,
        id_despedida: 0,
        empresa: "",
        capela: "",
        dataHoraInicial: "",
        dataHoraFinal: "",
        status: true,
      };
    },
    // Abrir o pop-up e verificar se a despedida já possui capela cadastrada
    async abrirModalCapela(idDespedida) {
      this.dialoCapela = true;
      this.capela.id_despedida = idDespedida;

      try {
        const capelaExistente = await this.buscarCapela(idDespedida);
        if (capelaExistente.length > 0) {
          // Preencher apenas os campos esperados
          this.capela = {
            id: capelaExistente[0].id,
            id_despedida: capelaExistente[0].id_despedida,
            empresa: capelaExistente[0].empresa,
            capela: capelaExistente[0].capela,
            dataHoraInicial: capelaExistente[0].dataHoraInicial,
            dataHoraFinal: capelaExistente[0].dataHoraFinal,
            status: capelaExistente[0].status,
            status_camera: capelaExistente[0].status_camera,
          };
        }
      } catch (error) {
        console.error("Erro ao buscar capela:", error);
        toast.error("Erro ao carregar capela.");
      }
    },

    // Buscar capela associada à despedida
    async buscarCapela(idDespedida) {
      try {
        const response = await http.get(
          `apresentacao/despedida/${idDespedida}`,
          {
            headers: authHeader(),
          },
        );

        return Array.isArray(response.data) ? response.data : []; // Garantir que seja um array
      } catch (error) {
        console.error("Erro ao consultar capela:", error);
        return []; // Retorna array vazio para evitar erro na atribuição
      }
    },

    // Salvar ou atualizar capela com base na existência do ID
    async salvarCapela() {
      if (
        !this.capela.empresa ||
        !this.capela.capela ||
        !this.capela.id_despedida ||
        !this.capela.dataHoraInicial ||
        !this.capela.dataHoraFinal
      ) {
        toast.error("Preencha todos os campos obrigatórios!");
        return;
      }

      if (this.capela.id > 0) {
        await this.atualizarCapela();
      } else {
        await this.cadastrarCapela();
      }
    },

    // Atualizar capela já existente
    async atualizarCapela() {
      try {
        await http.put("apresentacao/update", this.capela, {
          headers: authHeader(),
        });

        this.dialoCapela = false;
        toast.success("Capela editada com sucesso!");

        // Recarregar despedidas para obter informações atualizadas
        this.consultarDespedidas();
      } catch (error) {
        if (
          error.response.status === 400 &&
          error.response.data ==
            "Já existe outro registro ativo para esta empresa"
        ) {
          toast.error("Capela já vinculada a outra cerimônia!");
        } else {
          toast.error("Erro ao editar capela.");
        }
        console.error("Erro ao editar capela:", error);
      }
    },

    // Criar uma nova capela
    async cadastrarCapela() {
      try {
        await http.post("apresentacao/salva", this.capela, {
          headers: authHeader(),
        });

        this.dialoCapela = false;
        toast.success("Capela salva com sucesso!");
        this.despedidas(); // Atualiza a lista de despedidas
      } catch (error) {
        if (
          error.response.status === 400 &&
          error.response.data ==
            "Já existe outro registro ativo para esta empresa"
        ) {
          toast.error("Capela já vinculada a outra cerimônia!");
        } else {
          toast.error("Erro ao editar capela.");
        }
        console.error("Erro ao editar capela:", error);
      }
    },
    async modificarStatusDespedida(item) {
      this.loadingStatus = true;
      try {
        const response = await http.post(
          "cliente/update-despedida-status",
          {
            id: item.id,
            status_memoria: !item.status_memoria,
          },
          {
            headers: authHeader(),
          },
        );
        console.log("depois" + item.status_memoria);
        toast.success(
          `Despedida ${
            !item.status_memoria ? "ativada" : "desativada"
          } com sucesso!`,
        );
        if (!response) {
          console.log(response);
        }
        this.despedidas();
        this.loadingStatus = false;
      } catch (error) {
        console.error("Erro ao cadastrar despedida:", error);
        this.loadingStatus = false;
        throw error;
      }
    },
    copiarLink(value) {
      navigator.clipboard
        .writeText(value)
        .then(() => {})
        .catch((err) => {
          console.error("Erro ao copiar:", err);
        });
      toast.success("Link copiado para área de transferência!");
    },
    maskPhone(phone) {
      if (phone === null || phone === undefined) {
        return "";
      }
      phone = phone.replace(/\D/g, "");
      if (phone.length > 2) {
        phone = "(" + phone.slice(0, 2) + ") " + phone.slice(2);
      }
      if (phone.length > 10) {
        phone = phone.slice(0, 10) + " " + phone.slice(10);
      }
      if (phone.length > 15) {
        phone = phone.slice(0, 15);
      }
      return phone;
    },
    formatDate(date) {
      if (!date) return "";
      return dayjs(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    setRolesFromSession() {
      const user = JSON.parse(sessionStorage.getItem("user"));
      const roles = user?.roles || [];

      this.roles = Array.isArray(roles) ? roles : [];
    },
    handlePageChange() {
      // Quando a página mudar, recarregar os dados
      if (!this.isOnlyModerador) {
        if (this.isBuscaAtiva) {
          this.buscarDespedidas();
        } else {
          this.despedidasGeral();
        }
      }
    },

    // Método para buscar despedidas por nome ou ID
    buscarDespedidas() {
      if (!this.searchValue) return;

      this.loading = true;
      this.isBuscaAtiva = true;
      this.currentPage = 1; // Resetar para primeira página na busca

      // A API de busca retorna um array simples com todos os resultados
      // Não precisa de parâmetros de paginação
      http
        .get("cliente/despedidas/busca", {
          headers: authHeader(),
          params: {
            valor: this.searchValue,
          },
        })
        .then((response) => {
          const data = response.data;

          // A API retorna um array simples com todos os resultados
          this.serverItems = Array.isArray(data) ? data : [];
          this.totalItems = this.serverItems.length;
          this.totalPages = 1; // Resultados de busca não são paginados no servidor

          this.loading = false;
        })
        .catch((error) => {
          console.error("Erro ao buscar despedidas:", error);
          this.loading = false;
        });
    },

    // Método para limpar a busca e voltar à listagem normal
    limparBusca() {
      this.searchValue = "";
      this.isBuscaAtiva = false;
      this.currentPage = 1;
      this.despedidasGeral();
    },

    consultarDespedidas() {
      this.loading = true;

      if (this.isOnlyModerador) {
        this.despedidasModerador();
      } else {
        this.despedidasGeral();
      }
    },

    despedidasGeral() {
      this.loading = true;

      // Se estiver em modo de busca e não for moderador, usar a rota de busca
      if (this.isBuscaAtiva && !this.isOnlyModerador && this.searchValue) {
        this.buscarDespedidas();
        return;
      }

      const rota = "cliente/despedidas";

      // Adicionar parâmetros de paginação apenas quando não for moderador
      const params = !this.isOnlyModerador
        ? {
            page: this.currentPage - 1, // API espera página baseada em 0
            size: this.itemsPerPage,
          }
        : {};

      http
        .get(rota, {
          headers: authHeader(),
          params: params,
        })
        .then((response) => {
          const data = response.data;

          if (!this.isOnlyModerador && data.content) {
            // Resposta paginada
            this.serverItems = Array.isArray(data.content) ? data.content : [];
            this.totalItems = data.totalElements || 0;
            this.totalPages = data.totalPages || 1;
          } else {
            // Resposta não paginada (para moderador ou formato antigo)
            this.serverItems = Array.isArray(data) ? data : [];
            this.totalItems = this.serverItems.length;
          }

          this.loading = false;
        })
        .catch((error) => {
          console.error("Erro ao consultar:", error);
          this.loading = false;
        });
    },

    despedidasModerador() {
      this.loading = true;

      const rota = "cliente/despedidas-moderacao";

      http
        .get(rota, {
          headers: authHeader(),
        })
        .then((response) => {
          const data = response.data;

          this.serverItems = Array.isArray(data) ? data : [];

          this.totalItems = this.serverItems.length;
          this.loading = false;
        })
        .catch((error) => {
          console.error("Erro ao consultar:", error);
          this.loading = false;
        });
    },
    novoPost() {
      this.$router.push("/admin/criardespedida");
    },
    gerenciarDespedida(cod) {
      this.$router.push("/admin/editardespedida/" + cod);
    },
    gerenciarMensagens(cod) {
      this.$router.push("/admin/mensagens/" + cod);
    },
    abrirDespedida(cod) {
      const url = this.codigo
        ? `${window.location.origin}/despedida/${cod}/${this.codigo}`
        : `${window.location.origin}/despedida/${cod}`;
      window.open(url, "_blank");
    },
    gerarQrCode(cod) {
      this.dialogCompartilhar = true;
      this.value_qrcode = urlBase + "/despedidas/" + cod;
      this.linkGrupoDespedidas = urlBase + "/despedidas/" + cod;
    },
    downloadQRCode() {
      const canvas = this.$refs.qrCodeContainer.querySelector("canvas");
      if (canvas) {
        const link = document.createElement("a");
        link.download = "qrcode-memorial.png";
        link.href = canvas.toDataURL("image/png");
        link.click();
        toast.success("QR Code baixado com sucesso!");
      }
    },
    async consultarMensagens(id) {
      try {
        const response = await http.get(`homenagem/homenagem-aprovadas/${id}`);
        return response.data;
      } catch (error) {
        console.error("Erro ao buscar mensagens:", error);
      }
    },

    async downloadEBook(item) {
      const mensagens = await this.consultarMensagens(item.id);
      this.despedidaAtual = item;
      this.despedidaAtual.mensagens = mensagens;

      this.renderizarEbook = true;

      setTimeout(async () => {
        const ebookElement = document.getElementById("ebook-container");

        if (!ebookElement) {
          toast.error("Elemento do ebook não encontrado");
          this.renderizarEbook = false;
          return;
        }

        try {
          await injectFotoPerfilParaExport(ebookElement, this.despedidaAtual);
          await waitForImagesInElement(ebookElement);
          const dataUrl = await toPng(ebookElement, toPngExportOptions);
          const pdf = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
          });

          const pdfWidth = pdf.internal.pageSize.getWidth();
          const pdfHeight = pdf.internal.pageSize.getHeight();

          const img = new Image();
          img.src = dataUrl;
          img.onload = () => {
            const imgWidth = pdfWidth;
            const imgHeight = (img.height * pdfWidth) / img.width;

            let heightLeft = imgHeight;
            let position = 0;

            pdf.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pdfHeight;

            while (heightLeft > 0) {
              position = heightLeft - imgHeight;
              pdf.addPage();
              pdf.addImage(dataUrl, "PNG", 0, position, imgWidth, imgHeight);
              heightLeft -= pdfHeight;
            }

            pdf.save(
              `ebook-${
                this.despedidaAtual?.pessoa_falecida?.nome || "falecido"
              }.pdf`,
            );
            toast.success("Ebook em PDF baixado com sucesso!");
            this.renderizarEbook = false;
          };
        } catch (error) {
          console.error("Erro ao gerar o PDF:", error);
          toast.error("Erro ao gerar o PDF do ebook");
          this.renderizarEbook = false;
        }
      }, 500);
    },
    downloadInformativo(item) {
      // Define a despedida atual para o componente Informativo
      this.despedidaAtual = item;

      // Mostra o componente oculto (fora da tela)
      this.renderizarInformativo = true;

      // Aguarda o componente ser renderizado
      setTimeout(async () => {
        const informativoElement = document.getElementById(
          "informativo-container"
        );

        if (!informativoElement) {
          toast.error("Elemento do informativo não encontrado");
          this.renderizarInformativo = false;
          return;
        }

        try {
          await injectFotoPerfilParaExport(
            informativoElement,
            this.despedidaAtual
          );
          await waitForImagesInElement(informativoElement);
          const dataUrl = await toPng(
            informativoElement,
            toPngExportOptions
          );
          const link = document.createElement("a");
          link.download = `informativo-${
            this.despedidaAtual?.pessoa_falecida?.nome || "falecido"
          }.png`;
          link.href = dataUrl;
          link.click();
          toast.success("Informativo baixado com sucesso!");
          this.renderizarInformativo = false;
        } catch (error) {
          console.error("Erro ao gerar a imagem:", error);
          toast.error("Erro ao gerar a imagem do informativo");
          this.renderizarInformativo = false;
        }
      }, 500);
    },
    ajustarModerador(moderador, despedida) {
      if (moderador) {
        this.$router.push(`/admin/editar-moderador/${despedida}`);
      } else {
        this.$router.push(`/admin/criar-moderador/${despedida}`);
      }
      // Redirecionar para a página de ajuste de moderador
      //this.$router.push(`/admin/moderador/${id}`);
    },
  },
};
</script>

<style scoped>
.v-main {
  background-color: #f5f5f5;
}
.container {
  min-height: 78vh !important;
  padding-top: 2rem;
}

.foto_perfil {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 100%;
  margin-right: 1rem;
}

.botao {
  margin-bottom: 0.6rem;
  margin-right: 0.4rem;
  font-weight: bold;
}

.actions-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding-top: 1rem;
}

.action-item {
  margin-left: 8px;
}

.icon {
  margin-left: 8px;
}
</style>
